import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
        userId: '',
        userPower: '',
        isLoggedIn: false,

        className: '',
        classId: '',
        studentCount: 0,

        selectedHomework: {
            name: "",
            description: "",
            attachment: "",
            deadline: "",
            release_time: "",
            teacher: {},
            comments: [],
            student_count: 0, answer_count: 0, corrected_answer_count: 0
        }
    },
    mutations: {
        changeLogin: function (state, user) {
            state.token = user.token;
            state.userId = user.user_id;
            state.userPower = user.user_power;
            state.isLoggedIn = true;
            localStorage.setItem('token', user.token);
        },
        handleLogout: function (state) {
            state.token = '',
                state.userId = '',
                state.userPower = '',
                state.isLoggedIn = false;
            localStorage.removeItem('token')
        },
        setCurrentClass: function (state, payload) {
            state.className = payload.name;
            state.classId = payload.id;
            state.studentCount = payload.students.length;
        },
        setCurrentHomework: function (state, payload) {
            state.selectedHomework = payload
        },
        clearCurrentHomework: function(state) {
            state.selectedHomework = {
                name: "",
                description: "",
                attachment: "",
                deadline: "",
                release_time: "",
                teacher: {},
                comments: [],
                student_count: 0, answer_count: 0, corrected_answer_count: 0
            };
        }
    }
})

export default store;